/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RecommendationByEnginesQueryVariables = Types.Exact<{
  platformId: Types.Platform;
  market: Types.Market;
  engineNames:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
  abtestPools: Types.AbTestPool;
  modelIds:
    | Array<Types.Scalars['BigInteger']['input']>
    | Types.Scalars['BigInteger']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type RecommendationByEnginesQuery = { __typename?: 'Query' } & {
  recommendationEngines: Types.Maybe<
    Array<
      { __typename?: 'Engine' } & Pick<Types.Engine, 'engineName'> & {
          productCollection: { __typename?: 'ProductCollection' } & Pick<
            Types.ProductCollection,
            'modelIds'
          >;
        }
    >
  >;
};

export const RecommendationByEnginesDocument = /*#__PURE__*/ `
    query RecommendationByEngines($platformId: Platform!, $market: Market!, $engineNames: [String!]!, $abtestPools: ABTestPool!, $modelIds: [BigInteger!]!, $limit: Int) {
  recommendationEngines: recommendationsByEngine(
    abtestPools: $abtestPools
    platformId: $platformId
    market: $market
    engineNames: $engineNames
    modelIds: $modelIds
    limit: $limit
  ) {
    engineName
    productCollection {
      modelIds
    }
  }
}
    `;

export function useRecommendationByEnginesQuery(
  options: Omit<
    Urql.UseQueryArgs<RecommendationByEnginesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    RecommendationByEnginesQuery,
    RecommendationByEnginesQueryVariables
  >({ query: RecommendationByEnginesDocument, ...options });
}
